import type { JSX } from 'react';
import type { ServiceCode } from '@common/enums';
import type { EchographyAdditionalQuestionResponseData } from '@common/validation/customControls/echography/echographyAdditionalQuestionResponse';
import { CustomControlCode } from '@common/enums';
import { useProcessActivityContext, useProcessActivityReadContext } from '@frontend/utils';
import { AdditionalQuestionRead } from '../../additionalQuestionAndAnswer/AdditionalQuestionRead';

export function EchographyAdditionalQuestionResponseRead(): JSX.Element {
    const { processData } = useProcessActivityContext<ServiceCode.Echography>();
    const { processActivity } = useProcessActivityReadContext<EchographyAdditionalQuestionResponseData>();

    return (
        <>
            <AdditionalQuestionRead
                customControlCode={CustomControlCode.EchographyAdditionalQuestionRequest}
                message={processData?.vraag}
            />
            <AdditionalQuestionRead
                customControlCode={CustomControlCode.EchographyAdditionalQuestionResponse}
                message={processActivity.customControlData.bericht}
            />
        </>
    );
}
